import each from 'lodash/each';
import {
  FEATURE,
  FeatureGroup,
  transformFeaturesToIdentifierObject,
  useFeaturesStore,
} from '@/features/Features';
import type { Merkmale } from '@/features/Global/types';
import { getCurrentSpartenConfig } from '@/utils/getCurrentSpartenConfig/getCurrentSpartenConfig';
import { useInputStore } from '@/features/Sparten';
import { STEP } from '@/router/steps';

export const buildFeatureObject = (): Merkmale => {
  const result: Merkmale = [];
  const featuresStore = useFeaturesStore();

  const overrideSchemas =
    getCurrentSpartenConfig().overrideFeatureValueWhen ?? {};

  let relevantFeatures = featuresStore.data;
  const { featureFilterFunction } = getCurrentSpartenConfig();
  if (featureFilterFunction) {
    relevantFeatures = featureFilterFunction(STEP.INPUT);
  }

  each(
    transformFeaturesToIdentifierObject(relevantFeatures as FeatureGroup[]),
    (feature, identifier) => {
      let { value } = feature;
      const overrideSchema = overrideSchemas[feature.identifier];
      if (overrideSchema !== undefined) {
        value = overrideSchema.isValidSync(useInputStore())
          ? FEATURE.CHECKED
          : FEATURE.UNCHECKED;

        featuresStore.byIdentifier[feature.identifier].value = value;
      }

      result.push({
        identifier,
        value,
      });
    },
  );

  return result;
};
